<template>
    <div class="ion-page">
        <ion-header class="rp-mobile">
            <ion-toolbar class="mobile-header-toolbar">
                <ion-buttons>
                <ion-menu-button></ion-menu-button>
                <ion-title>Help Video</ion-title>
                <ion-icon :icon="homeSharp" class="ion-margin ios" @click="homePage" v-if="userRoleId != 4"></ion-icon>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>
        <ion-header class="rp-desktop">
            <ion-toolbar>
                <ion-buttons slot="start">
                <ion-menu-button></ion-menu-button>
                </ion-buttons>
                <ion-title>Help Video</ion-title>
            </ion-toolbar>
        </ion-header>
        <ion-content>
            <div class="page-content">
                <div v-html="compiledHtml"></div>
            </div>
        </ion-content>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import axios from 'axios'
import { config } from "../../config";
import { homeSharp } from "ionicons/icons";
import { IonButtons, IonContent, IonHeader, IonIcon, IonMenuButton, IonTitle, IonToolbar } from "@ionic/vue";

export default defineComponent ({
    name: 'about',
    components: { IonHeader, IonToolbar, IonButtons, IonMenuButton, IonTitle, IonIcon, IonContent },
    data() {
        return {
            homeSharp,
            fileName: "helpVideo.html",
            input: "",
            userRoleId: ''
        }
    },
    created() {
        this.userRoleId = window.localStorage.getItem("user.roleId")
        // if(userRoleId != 4) {
            this.fileName = config.weblinks.helpVideo;
        // } else {
        //     this.fileName = config.weblinks.helpVideo;
        // }
        this.loadFile();
    },
    computed: {
        compiledHtml: function() {
            return this.input;
        }
    },
    methods: {
        loadFile() {
            axios({
                method: "get",
                url: this.fileName
            })
            .then(result => {
                this.input = result.data;
                })
                .catch(error => {
                console.error("error getting file");
            });
        },
        homePage() {
            let userRole = localStorage.getItem("user.roleId")
            if(userRole == 2) {
                this.$router.push("/customer/reservation")
            }
        },
    }
})
</script>

<style scoped>
.ios ion-icon {
  color: white;
  position: relative;
  left:70%;
}

.page-content {
    padding: 25px;
}

@media (max-width: 768px) {
  .mobile-header-toolbar {
    --background: #21b24b;
  }
  .mobile-header-toolbar {
    height: 56px;
    padding-top: 1px;
  }
  .mobile-header-toolbar ion-title {
    color: #ffffff;
  }
  .mobile-header-toolbar ion-buttons {
    color: #ffffff;
    --background: #ffffff;
  }
  .mobile-header-toolbar ion-menu-button {
    color: #ffffff;
    margin-right: 13px;
  }
}


</style>